import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ArrowRight, Calculator } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';

const CALCULATORS = [
  ['EMI Calculator', '/calculators/emi', 'Calculate monthly EMIs for any financing amount, rate and tenure'],
  ['Loan Eligibility Calculator', '/calculators/eligibility', 'Estimate how much financing your income profile supports'],
  ['Overdraft Calculator', '/calculators/overdraft', 'Work out interest costs on overdraft utilisation'],
  ['Home Loan Overdraft Calculator', '/calculators/home-loan-overdraft', 'See interest saved by parking surplus funds in an overdraft account'],
  ['Home Loan Balance Transfer Calculator', '/calculators/balance-transfer', 'Compare savings from moving to a lower rate'],
  ['Buy Vs Rent Calculator', '/calculators/buy-vs-rent', 'Compare long-term wealth outcomes of buying versus renting'],
  ['Loan Prepayment Calculator', '/calculators/prepayment', 'See how part-prepayments cut interest and shorten tenure']
];

const CalculatorsHubPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WhatsAppButton />

      <div className="bg-white pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500 mb-4 sm:mb-6">
              <Link to="/" className="hover:text-emerald-600 transition-colors">Home</Link>
              <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
              <span className="text-slate-700 font-medium">Calculators</span>
            </nav>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-3 sm:mb-4 leading-[1.1]">
              Financial <span className="text-emerald-600">Calculators</span>
            </h1>
            <p className="text-lg sm:text-xl text-slate-600 mb-10 sm:mb-12 max-w-3xl">
              Free tools to evaluate EMIs, eligibility, overdraft economics and financing decisions before you structure the requirement.
            </p>

            <div className="grid sm:grid-cols-2 gap-4" data-testid="calculators-hub-grid">
              {CALCULATORS.map(([label, to, desc]) => (
                <Link
                  key={to}
                  to={to}
                  className="group flex items-start gap-4 bg-white rounded-xl border-2 border-slate-200 hover:border-emerald-500 hover:shadow-lg transition-all duration-300 p-6"
                  data-testid={`calc-hub-${to.split('/').pop()}`}
                >
                  <div className="w-11 h-11 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-600 transition-colors">
                    <Calculator className="w-5 h-5 text-emerald-600 group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <h2 className="font-bold text-slate-900 group-hover:text-emerald-700 transition-colors text-lg">{label}</h2>
                    <p className="text-sm text-slate-600 mt-1">{desc}</p>
                  </div>
                  <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-emerald-500 ml-auto mt-1 flex-shrink-0 transition-colors" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CalculatorsHubPage;
